module.exports = __webpack_public_path__ + "static/media/fac13.bb8d9a85.jpg";